export const SET_PAYMENTTABLEFILTER = "SET_PAYMENTTABLEFILTER";
export const SET_SELECTEDCUSTOMERDATA = "SET_SELECTEDCUSTOMERDATA";
